import { SoSelectObjectItem } from "@/types/components/SoSelect"

export const REQUEST_REASON_OPTIONS: SoSelectObjectItem[] = [
  { value: "Meter read validation", title: "Meter read validation" },
  { value: "Meter technical details", title: "Meter technical details" },
  { value: "Disputed meter reads", title: "Disputed meter reads" },
]

export const FRESHDESK_GROUP_OPTIONS =
  __APP_ENV__ === "production"
    ? [
        7000022306, 7000023316, 7000022309, 7000022040, 7000023538, 7000022263,
        7000022308, 7000024013, 7000022307, 7000019979, 7000023205, 7000005574,
        7000023837, 7000022788,
      ]
    : [
        1007000022306, 1007000023316, 1007000022309, 1007000022040,
        1007000023538, 1007000022263, 1007000022308, 1007000024013,
        1007000022307, 1007000019979, 1007000023205, 1007000005574,
        1007000023837, 1007000022788,
      ]
